import React from "react";
import useDistinctShape from "@ui/lib/hooks/useDistinctShape";
import { ChannelMultiplexerContext } from "./useChannelMultiplexer";
// TODO: FIX FRONT IS DEPENDENT ON API TYPES

import type {
  Channel,
  ServerMessage,
} from "../../../../service-diagnostics-core/src/websocket/Message";

// a channel is a websocket connection to a controller instance on the backend, used to listen to anything that happens on the backend
// the channel key indicates the controller's name on the backend, and the full channel params automatically maps to a distinct controller instance (one instance by channel params JSON.stringify)
// data goes only from the backend to the frontend, the frontend cannot send data to the backend (that would require using a lower level hook on useWSClient)
export const useChannel = <T extends Channel>(
  channel: T,
  onMessage: (message: ServerMessage<T>["payload"]) => void, // called when a message is received on the channel from the backend controller instance
  once: boolean, // do not trigger onMessage for more than one instance of useChannel with the same channel (the older one registered will trigger)
  doIt?: boolean,
) => {
  const stableChannel = useDistinctShape(channel);
  const subscribe = React.useContext(ChannelMultiplexerContext);
  if (subscribe === undefined)
    throw new Error("useChannel must be used within a SubscribeProvider");

  React.useEffect(() => {
    if (doIt === false) return () => {};
    return subscribe(stableChannel, onMessage, once);
  }, [stableChannel, onMessage, subscribe, once, doIt]);
};
